import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="blog space-y-4 flex flex-col justify-center items-center min-h-screen">
      <div className="w-10/12 mx-auto">
        <h1 className="text-sm md:text-md text-justify text-black">
          The Project was built using React Js, Tailwind, axios for api
          requests(get, post, put, delete), useParams hook for populating forms
          dynamically, useHistory hook for navigating pages, react router,
          useContext hook for state anfd props management.
        </h1>
      </div>

      <Link
        className="bg-gray-800 w-3/6 md:w-1/6 rounded-2xl p-3 text-center text-sm md:text-base text-white"
        to="/"
      >
        Back To Posts
      </Link>
    </div>
  );
};

export default About;
